import React, { useMemo, useState } from "react"
import { StaticImage } from "gatsby-plugin-image"
import useQueryParams from "query-params-hook"
import { replaceByDict } from "../utilities/replace-by-dict"
import Stores from "./stores"

export type DownloadPopupType = {
  onCloseClick: () => void | null
  show: boolean
}

const DownloadPopup = ({ show, onCloseClick }: DownloadPopupType) => {

  const { lp: lpPages, campaignid, adgroupid, keyword, adid, lpurl, gclid} = useQueryParams()
  const isLpPage = lpPages === "true";

  const replaceHashed = useMemo(
    () => ({ campaignid, adgroupid, keyword, adid, lpurl, gclid }),
    [campaignid, adgroupid, keyword, adid, lpurl, gclid]
  );

  const storesLinks = useMemo(() => {
    return (isLpPage ? 
      [
        {name: "Google", desktop: replaceByDict("https://app.adjust.com/xmapw1z?campaign={campaignid}&adgroup={adgroupid}&creative={keyword}_{adid}&lpurl={lpurl}&external_click_id={gclid}", replaceHashed)},
        {name: "Apple", desktop: replaceByDict("https://app.adjust.com/nkxn20i?campaign={campaignid}&adgroup={adgroupid}&creative={keyword}_{adid}&lpurl={lpurl}&external_click_id={gclid}&redirect=https://apps.apple.com/app/id945621521?ppid=f515ce68-eb0a-4115-8c92-e4ade2811b09", replaceHashed)},
      ] : [
        {name: "Google", desktop: "https://app.adjust.com/118bkc27"},
        {name: "Apple", desktop: "https://app.adjust.com/11f94w7s"},
        {name: "Amazon", desktop: "https://app.adjust.com/11pm9l29"},
        {name: "Facebook", desktop: "https://apps.facebook.com/quickhitslots/?source=quickhitslots.com&campaign_id=popupbadges"},
      ]
    )
  }, [isLpPage, replaceHashed]);


  return (
    <>
      <div
        onClick={onCloseClick}
        className={`popup-overlay${show ? " show-popup" : " hide-popup"}`}
      ></div>
      <div
        className={`download-popup py-7 px-4 sm:px-10 text-white md:flex md:justify-center${
          show ? " show-popup" : " hide-popup"
        }`}
        style={
          typeof window !== `undefined`
            ? { top: `${window.scrollY + 100}px` }
            : {}
        }
      >
        <div className='flex flex-col space-y-5 items-center'>
          <button className='close-popup text-5xl' onClick={onCloseClick}>
            X
          </button>
          <div className='flex gap-14'>
            <div className='invisible'>
              <StaticImage
                src='../images/popup/qht-popup.png'
                alt=''
                width={340}
              />
            </div>

            <div className='flex flex-col items-center justify-center space-y-2'>
              <div className='download-popup-title'>DOWNLOAD & PLAY</div>

              <div className='code-qr text-4xl text-center uppercase font-bold text-yellow-300'>
                scan qr code to play
                <div className='mt-5 pb-5'>
                  <StaticImage
                    src='../images/qr-code.png'
                    alt='qr code - scan to play'
                    width={170}
                  />
                </div>
              </div>

              <Stores
                twoLines={true}
                links={storesLinks}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DownloadPopup
